
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7 7.56a1.061 1.061 0 00-1.81-.75L.71 11.29a1 1 0 000 1.41l4.48 4.48a1.057 1.057 0 101.5-1.49L3 12l3.69-3.69A1.06 1.06 0 007 7.56zM13 9V7.41a1 1 0 00-1.71-.71L6.7 11.29a1 1 0 000 1.41l4.59 4.59a1 1 0 001.71-.71V14.9c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"}})])
          )
        }
      }
    